import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'closeoutFiles';

// PAGINATION
export const paginationCloseOutFiles = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllCloseOutFiles = async (filters) => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createCloseOutFile = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateCloseOutFile = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteCloseOutFile = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

paginationCloseOutFiles.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllCloseOutFiles.propTypes = {
  filters: PropTypes.object.isRequired,
};

createCloseOutFile.propTypes = {
  values: PropTypes.object.isRequired,
};

updateCloseOutFile.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteCloseOutFile.propTypes = {
  id: PropTypes.string.isRequired,
};
